'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetLocation = undefined;

var _reselect = require('reselect');

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _getLatestWidgetData = require('../../widget-data/selectors/getLatestWidgetData');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getWidgetLocation = exports.getWidgetLocation = (0, _reselect.createSelector)([_getLatestWidgetData.getLatestWidgetData], function (state) {
  return (0, _getIn2.default)(['widgetLocation'], state);
});